"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ServiceFetch_1 = __importDefault(require("../../../utilities/ServiceFetch"));
var NifUnitTypeEnum_1 = __importDefault(require("./enums/NifUnitTypeEnum"));
var utilities_1 = require("@ikea-aoa/utilities");
/**
 * This class is used for CRUD operations for NIF eCommerce API.
 */
var NifCartService = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param options Options.
     * @param options.locale Locale.
     * @param options.endpoint Endpoint.
     * @param options.clientId Client ID.
     * @param options.clientSecret Client secret.
     */
    function NifCartService(options) {
        this.locale = options.locale;
        this.endpoint = options.endpoint;
    }
    /**
     * Adds items to shopping cart.
     *
     * @param options Options.
     * @param options.items Array of shopping items.
     * @returns Promise object.
     */
    NifCartService.prototype.addToCart = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var carts, cart, _a, cartCount;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getCarts()];
                    case 1:
                        carts = _b.sent();
                        if (!(carts.length > 0)) return [3 /*break*/, 2];
                        _a = carts[0];
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.createCart(NifUnitTypeEnum_1.default.retailUnit)];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        cart = _a;
                        return [4 /*yield*/, this.addCartItems({ items: options.items, cartId: cart.id })];
                    case 5:
                        _b.sent();
                        return [4 /*yield*/, this.getCartCountById(cart.id)];
                    case 6:
                        cartCount = _b.sent();
                        return [2 /*return*/, {
                                errorList: [],
                                cartCount: cartCount
                            }];
                }
            });
        });
    };
    /**
     * Fetches and returns the cart count.
     *
     * @returns Promise object.
     */
    NifCartService.prototype.getCartCount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var carts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCarts()];
                    case 1:
                        carts = _a.sent();
                        if (carts.length > 0) {
                            return [2 /*return*/, this.getCartCountById(carts[0].id)];
                        }
                        return [2 /*return*/, 0];
                }
            });
        });
    };
    /**
     * Fetches and returns the cart count.
     *
     * @param cartId Cart id.
     * @returns Promise object.
     */
    NifCartService.prototype.getCartCountById = function (cartId) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ServiceFetch_1.default.json(this.endpoint + "/carts/" + cartId, {
                            method: 'GET',
                            credentials: 'include',
                            headers: {
                                Accept: 'application/json'
                            }
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response['quantity'] || 0];
                }
            });
        });
    };
    /**
     * Fetches all carts and returns them. Returns an empty array if 0 (zero) carts.
     *
     * @returns Promise object.
     */
    NifCartService.prototype.getCarts = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ServiceFetch_1.default.json(this.endpoint + "/carts", {
                            method: 'GET',
                            credentials: 'include',
                            headers: {
                                Accept: 'application/json'
                            }
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates a cart and returns the created cart.
     *
     * @param [retailUnitType] The type of unit (ru = Retail Unit/Market or sto = Store).
     * @returns Promise object.
     */
    NifCartService.prototype.createCart = function (retailUnitType) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, country, language;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = utilities_1.LocaleUtility.getCountryAndLanguage(this.locale), country = _a.country, language = _a.language;
                        return [4 /*yield*/, ServiceFetch_1.default.json(this.endpoint + "/carts", {
                                method: 'POST',
                                credentials: 'include',
                                headers: {
                                    Accept: 'application/json',
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                    context: {
                                        id: country,
                                        type: retailUnitType
                                    },
                                    countryCode: country,
                                    languageCode: language
                                })
                            })];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /**
     * Add cart items to cart.
     *
     * @param options Configuration.
     * @param options.items Array of shopping items.
     * @param options.cartId Cart id.
     * @returns Promise object.
     */
    NifCartService.prototype.addCartItems = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ServiceFetch_1.default.text(this.endpoint + "/carts/" + options.cartId + "/items", {
                            method: 'POST',
                            credentials: 'include',
                            headers: {
                                Accept: 'application/json',
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                items: options.items.map(function (item) {
                                    return {
                                        itemNo: item.id,
                                        type: item.type,
                                        quantity: item.quantity
                                    };
                                })
                            })
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return NifCartService;
}());
exports.default = NifCartService;
//# sourceMappingURL=NifCartService.js.map